module.exports = __webpack_public_path__ + "static/media/headshot.a7b5ec51.jpg";